import * as React from 'react';
import config from '../commonData';
export default function Loader() {
    return (
        <div id="spinner-container">
            <div id="spinner">
                <div>{config.societe == 1 ? 'UNICARS' : config.societe == 0 ? 'DEPOT' : 'CHARGEMENT'}</div>
            </div>
        </div>
    );
}
